import IconTextButton from "../../../../components/iconTextButton/IconTextButton";
import { Add20Regular, ArrowDownload20Regular, ArrowUpload20Regular, Checkmark20Regular } from "@fluentui/react-icons";
import { ILicenseWorksRowType } from "../../../../types/usageTypes/ILicenseWorksRowType";

export interface ILicensesMaintenanceWorkGridToolBar {

    data?: ILicenseWorksRowType[];
    hasChanges?: number[]
    showModal: () => void;
    disabled?: boolean;
    exportPrice: () => void;
    importPrice: (event) => void;
    importWork: (event) => void;
    calculatePrice: () => void;
    importDisabled?: boolean;
}

const LicensesMaintenanceWorkGridToolBar = (props: ILicensesMaintenanceWorkGridToolBar) => {

    const { showModal, disabled, exportPrice, importPrice, importWork, calculatePrice, importDisabled } = props;

    return (

        <div
            className="toolbarWrapper"
            id={"toolbar"}
        >
            <div style={{paddingLeft:"6px", paddingRight:"6px" , paddingBottom:"3px"}}>
                <IconTextButton text="Add Work" icon={Add20Regular} disabled={disabled}
                    onClick={() => showModal()} />
            </div>

            <div style={{ paddingLeft: "6px", paddingBottom:"3px" }}>
                <IconTextButton text="Calculate Price" icon={Checkmark20Regular} disabled={disabled} onClick={() => calculatePrice()}/>
            </div>

            <div style={{paddingLeft:"6px", paddingRight:"6px", paddingBottom:"3px"}}>
                <IconTextButton text="Export Price" icon={ArrowDownload20Regular} disabled={disabled} onClick={() => exportPrice()} />
            </div>

            <div style={{ paddingLeft: "6px", paddingRight: "6px", paddingBottom: "3px" }}>
                <div className={["IconTextButton", (disabled || importDisabled) && "disabled"].join(' ')} >
                    <label htmlFor="prices-file" id="fileinput-label" style={{ marginTop: "0px", marginBottom: "5px", fontFamily: "inherit" }}  >
                        <ArrowUpload20Regular data-testid={"icon-text-btn"} className="icon" />
                        Import Price
                    </label>
                </div>         
                <input type="file" onChange={importPrice} id="prices-file" hidden disabled={disabled || importDisabled} />
            </div>

            <div style={{ paddingLeft: "6px", paddingRight: "6px", paddingBottom: "3px" }}>
                <div className={["IconTextButton", (disabled) && "disabled"].join(' ')} >
                    <label htmlFor="works-file" id="fileinput-label" style={{ marginTop: "0px", marginBottom: "5px", fontFamily: "inherit" }}  >
                        <ArrowUpload20Regular data-testid={"icon-text-btn"} className="icon" />
                        Import Work
                    </label>
                </div>         
                <input type="file" onChange={importWork} id="works-file" hidden disabled={disabled} />
            </div>
        </div>
    );
}

export default LicensesMaintenanceWorkGridToolBar